<script>
	import {HeavenImage} from '../../../public/assets/urls'
</script>

<div class="battleground_bg">
	<img src={HeavenImage} class="bg_success" alt=""/>
</div>
